// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bg-3";
export var contentContainer = "_bg-0";
export var editorContainer = "_bg-1";
export var quillInputForm = "_bg-2";
export var zoneDivider = "_bg-4";